export default __webpack_public_path__ + "static/media/tailwind-logo.f6465245.png";